import service from "../../../@services";
export default class Supplier {
  #originData;
  get id() {
    return this.#originData.id;
  }
  get companyName() {
    return this.#originData.companyName;
  }
  get contactName() {
    return this.#originData.companyName;
  }
  get contactPhone() {
    return this.#originData.contactPhone;
  }
  get supplierName() {
    return this.#originData.supplierName;
  }
  get validity() {
    return this.#originData.validity;
  }
  get remark() {
    return this.#originData.remark;
  }
  constructor(supplier) {
    this.#originData = supplier;
  }
  async save() {
    let result;
    if (this.id) {
      result = await service.supplier.update(this.#originData);
    } else {
      result = await service.supplier.create(this.#originData);
    }
    service.common.getValidSupplierList();
    // store.dispatch({
    //   type: "common/suppliers/update",
    //   payload: this.#originData,
    // });
    return result;
  }
}
